// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"b2dfbfbc","116":"81b6bf8d","237":"2791de67","240":"b5edbfb9","453":"c5d7baa8","470":"1ba1d892","489":"36580da2","501":"49a1437b","559":"1561e006","671":"87f3309a","703":"e43e1cb5","833":"56efbbdd","847":"4e8f33db"}[chunkId] + ".chunk.js";
};